import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { api } from "@/lib/api";

export const DocumentPreview = ({ profile }) => {
  const [url, setUrl] = useState(null);
  const isImage = profile.document_type?.startsWith("image/");

  useEffect(() => {
    let objectUrl;
    if (isImage) {
      api.get("/profile/document", { responseType: "blob" }).then((r) => {
        objectUrl = URL.createObjectURL(r.data);
        setUrl(objectUrl);
      }).catch(() => setUrl(null));
    }
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [isImage, profile.updated_at]);

  return (
    <div data-testid="profile-document-preview" className="ff-card p-3 flex items-center gap-3">
      {isImage && url ? (
        <img src={url} alt="Documento licenza" className="h-16 w-24 object-cover rounded-lg border border-[#27272A]" />
      ) : (
        <div className="h-16 w-24 rounded-lg bg-black border border-[#27272A] flex items-center justify-center"><FileText size={24} className="text-[#94A3B8]" /></div>
      )}
      <div className="min-w-0">
        <p className="text-sm font-semibold text-white truncate">{profile.document_name}</p>
        <p className="text-xs text-[#10B981]">Caricato • archiviato in modo privato</p>
      </div>
    </div>
  );
};
